/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'resources/less/themes/base/pages/standalone/business.less';

$(function() {
    $('.file-input-remove input').on('change', function() {
        if (this.files.length > 0) {
            $(this)
                .closest('.file-input-remove')
                .find('.remove')
                .show();
        }
    });
    $('.file-input-remove .remove').on('click', function() {
        var $elem = $(this);
        if (confirm($elem.data('message'))) {
            $elem
                .parent()
                .find('input[type="file"]')
                .val('');
            $(this).hide();
        }
    });
});
